import React, { useState } from "react";
import { Box, Card, Grid2, Alert } from "@mui/material";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router";
import FormTextField from "../../../component/form/FormTextField";
import FormDropDown from "../../../component/form/FormDropDown";
import MuiButton from "../../../component/common/MuiButton";
import { useSnackbar } from "../../../component/common/Snackbar";
import ManageCities from "../../form/steps/personal-details/ManageCities";
import FormDateField from "../../../component/form/FormDateField";
import FormTelInput from "../../../component/form/FormTelInput";

export default function RightSection() {
  const API_ENDPOINT = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const deviceId = searchParams.get("deviceId");
  const [SnackbarComponent, showSnackbar] = useSnackbar();
  const { control, handleSubmit, reset, watch } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const reasonForUsingEkko = watch("reasonForUsing");

  const onSubmit = async (formData) => {
    setError(null);
    if (!deviceId) {
      const message = "Something's wrong with this link. Please try onboarding again.";
      setError(message);
      // showSnackbar(message, "error");
      return;
    }
    const data = {
      ...formData,
      city: formData.city.id,
      email: formData?.email?.toLowerCase(),
      deviceId,
    };
    if (data.reasonForUsing !== "Other") {
      delete data.otherReasonForUsingEkko;
    }
    setLoading(true);
    try {
      await axios.postForm(`${API_ENDPOINT}/clinic_register`, data);
      reset();
      navigate("/successful-submission");
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Oops! Something went wrong";
      setError(message);
      // showSnackbar(message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid2
      size={{ xs: 12, md: 9 }}
      sx={{
        padding: { xs: "16px", md: 4 },
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "start", md: "center" },
      }}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Card sx={{ mb: 4, padding: 4 }}>
        <Grid2 container spacing={2}>

           <Grid2 size={{ xs: 12, lg: 6 }}>
                 <FormTextField
                   placeholder="Guardian's name"
                   label="Guardian's name"
                   fieldname="guardianName"
                   control={control}
                   required
                   onlyText
                 />
               </Grid2>
           <Grid2 size={{ xs: 12, lg: 6 }}>
                 <FormTextField
                   placeholder="Patient's name"
                   label="Patient's name"
                   fieldname="patientName"
                   control={control}
                   required
                   onlyText
                 />
               </Grid2>
         
               <Grid2 size={{ xs: 12, lg: 6 }}>
                 <FormDropDown
                   label="Patient's gender"
                   fieldname="gender"
                   control={control}
                   required
                   dropdownValues={[
                     { label: "Male", value: "m" },
                     { label: "Female", value: "f" },
                   ]}
                 />
               </Grid2>
         
               <Grid2 size={{ xs: 12, lg: 6 }}>
                 <FormDateField
                   label="Patient's date of birth"
                   fieldname="dateOfBirth"
                   control={control}
                   required
                 />
               </Grid2>
         
               <Grid2 size={{ xs: 12, lg: 6 }}>
                 <FormTelInput
                   label="Guardian's phone no"
                   fieldname="phoneNumber"
                   required
                   control={control}
                 />
               </Grid2>

            <Grid2 size={{ xs: 12, lg: 6 }}>
                    <FormTextField
                      placeholder="Email address"
                      label="Guardian's email"
                      fieldname="email"
                      control={control}
                      required
                      rules={{
                        pattern: {
                          value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
                          message: "Invalid email",
                        },
                      }}
                    />
                  </Grid2>

       
 <ManageCities control={control} watch={watch} />

          <Grid2 size={{ xs: 12, lg: 6 }}>
            <FormTextField
              placeholder="Address"
              label="Address"
              fieldname="address1"
              control={control}
              required
            />
          </Grid2>
          <Grid2
            size={{ xs: 12, }}
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
          >
            <FormDropDown
              label="Reason (for using EKKO)"
              fieldname="reasonForUsing"
              control={control}
              required
              dropdownValues={[
                {
                  label: "Speech Sound Disorders/Speech Delay",
                  value: "Speech Sound Disorders/Speech Delay",
                },
                { label: "Dysarthria", value: "Dysarthria" },
                { label: "Selective Mutism", value: "Selective Mutism" },
                { label: "Autism", value: "Autism" },
                { label: "Apraxia", value: "Apraxia" },
                {
                  label: "Delayed Milestones/Development Delays",
                  value: "Delayed Milestones/Development Delays",
                },
                { label: "ADHD", value: "ADHD" },
                { label: "Behavioral Issues", value: "Behavioral Issues" },
                { label: "Other", value: "Other" },
              ]}
            />
          </Grid2>
          {reasonForUsingEkko === "Other" && (
            <Grid2 size={{ xs: 12 }}>
              <FormTextField
                placeholder="Please specify your reason"
                label="Other Reason"
                fieldname="otherReasonForUsingEkko"
                control={control}
                required
              />
            </Grid2>
          )}

         

          <Grid2 size={12}>
            <FormTextField
              placeholder="Type any additional details"
              label="Additional details"
              multiline
              fieldname="additionalDetails"
              control={control}
            />
          </Grid2>
        </Grid2>
      </Card>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <MuiButton type="submit" loading={loading}>
          Submit
        </MuiButton>
      </Box>

      <SnackbarComponent />
    </Grid2>
  );
}
